import { useEffect, useRef } from 'react';

export const useMountedRef = () => {
  // Track mounted state to not update state after unmounting
  const mountedRef = useRef(false);
  if (!mountedRef.current) {
    mountedRef.current = true;
  }
  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);
  return mountedRef;
};
